import { render, staticRenderFns } from "./IngredientItem.vue?vue&type=template&id=79739022&scoped=true&lang=pug&"
import script from "./IngredientItem.vue?vue&type=script&lang=js&"
export * from "./IngredientItem.vue?vue&type=script&lang=js&"
import style0 from "./IngredientItem.vue?vue&type=style&index=0&id=79739022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79739022",
  null
  
)

export default component.exports